module.exports = __webpack_public_path__ + "media/perpetual-depths.e35a1fa1.mp3";